import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Spin,
    Tabs,
} from "antd";
import { useState, useEffect } from "react";
import MainLayout from "./../../../components/mainLayout";
import "./Banner.scss";
import UploadMultiple from './../../../commons/UploadMultiple/UploadMultiple';
import BlockForm from './../../../components/form/blockForm';
import BannerForm from './../../../components/form/bannerForm';
import { authApis } from "./../../../services/authApi";
import { nofication } from './../../../commons/Nofication';
import { useParams } from 'react-router-dom';
import { ROOT_URL } from "../../../constants/api";
import BackButton from "../../../commons/BackButton";

const { TabPane } = Tabs;
const style = { padding: "8px 20px" };
const onChange = (key) => {
    console.log(key);
};

const AddBannerInvestor = () => {
    const [fileList, setFileList] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [idsRemove, setIdsRemove] = useState([]);
    const [imgCurrent, setImgCurrent] = useState([]);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const [bannerData, setBannerData] = useState(null); // Lưu data banner để đảm bảo có khi submit
    let { id } = useParams();
    const [content, setContent] = useState({
        content_vi: "",
        // content_en: "",
        // content_kr: "",
        // content_cn: "",
        // content_jp: "",

    });
    const onChangeContentValue = (lang) => {
        console.log('lang')
    }
    useEffect(() => {
        setLoading(true);
        authApis
            .getDetailBanner(1)
            .then((data) => {
                if (data.status_code === 200) {
                    console.log('Banner data loaded:', data.banner);
                    setBannerData(data.banner); // Lưu data banner
                    form.setFieldsValue(data.banner);
                    setImageUrl(data.images);
                    setImgCurrent(data.images);
                    setContent({
                        content_vi: data.banner?.content_vi ?? '<p></p>',
                        // content_en: data.banner?.content_en ?? '<p></p>',
                        // content_kr: data.banner?.content_kr ?? '<p></p>',
                        // content_cn: data.banner?.content_cn ?? '<p></p>',
                        // content_jp: data.banner?.content_jp ?? '<p></p>',
                    });
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            })
            .finally(() => {
                setLoading(false);
            });
    }, [])

    const onFinish = async () => {
        // Đảm bảo đã load data trước khi submit
        if (loading) {
            nofication('warning', 'Chờ', 'Đang tải dữ liệu, vui lòng chờ...');
            return;
        }

        const values = form.getFieldsValue(true);
        values.logo = undefined;
        const formData = new FormData();
        
        // QUAN TRỌNG: Luôn gửi id của banner (hardcode là 1 cho trang này)
        // Merge bannerData với values để đảm bảo có đầy đủ các field
        const mergedValues = { ...bannerData, ...values };
        
        // Đảm bảo các field content luôn được gửi với giá trị từ state content
        const contentFields = ['content_vi', 'content_en', 'content_kr', 'content_cn', 'content_jp'];
        
        for (var key in mergedValues) {
            if (mergedValues[key] === undefined || mergedValues[key] === null) {
                continue;
            }
            if (contentFields.includes(key)) {
                // Ưu tiên lấy từ editor, nếu không thì lấy từ values, cuối cùng là từ state content
                const editorValue = mergedValues[key]?.editor?.getData?.();
                const contentValue = editorValue || mergedValues[key] || content[key] || '';
                formData.append(key, contentValue);
            } else {
                formData.append(key, mergedValues[key]);
            }
        }
        
        // Đảm bảo các content field luôn được gửi dù không có trong values
        contentFields.forEach(field => {
            if (!formData.has(field) && content[field]) {
                formData.append(field, content[field]);
            }
        });
        
        // Luôn gửi id = 1 cho banner này (nếu chưa có)
        if (!formData.has('id')) {
            formData.append('id', bannerData?.id || 1);
        }
        
        console.log('fileList', fileList);
        if (fileList && fileList.length !== 0){
            for (let i = 0; i < fileList.length; i++) {
                formData.append('logo' + i, fileList[i])
                console.log('fileList[i]',fileList[i])
            }
        }
        formData.append('total', fileList && fileList.length)
        formData.append('idsRemove', idsRemove)
        formData.append('type', 0)
        await authApis
            .banner(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    setImageUrl([...data.images])
                    setFileList([])
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Khuôn viên"
            link="/banner/"
            titleNew="Về chúng tôi / Khuôn viên"
        >
            <Spin spinning={loading} tip="Đang tải dữ liệu...">
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true}>
                <Row gutter={16} style={{ minHeight: "873px" }}>
                    <Col span={24} className='pad'>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <BannerForm lang={'vi'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                {/* <TabPane tab="Tiếng anh" key="2">
                                    <BlockForm lang={'en'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng hàn" key="3">
                                    <BlockForm lang={'kr'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng trung" key="4">
                                    <BlockForm lang={'cn'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng nhật" key="5">
                                    <BlockForm lang={'jp'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane> */}
                            </Tabs>
                            <Form.Item label="Banner" colon={true}>
                                <UploadMultiple imageUrl={imageUrl} setFileList={setFileList} setImageUrl={setImageUrl} setIdsRemove={setIdsRemove} idsRemove={idsRemove} imgCurrent={imgCurrent} fileList={fileList} span={24} />
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
            </Spin>
        </MainLayout>
    );
};

export default AddBannerInvestor;
